"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Panel["default"];
  }
});
Object.defineProperty(exports, "panelThemeNamespace", {
  enumerable: true,
  get: function get() {
    return _themes.panelThemeNamespace;
  }
});
Object.defineProperty(exports, "panelClassicTheme", {
  enumerable: true,
  get: function get() {
    return _themes.panelClassicTheme;
  }
});
Object.defineProperty(exports, "panelDarkTheme", {
  enumerable: true,
  get: function get() {
    return _themes.panelDarkTheme;
  }
});

var _Panel = _interopRequireDefault(require("./Panel"));

var _themes = require("./themes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}